
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/markets",
      function () {
        return require("private-next-pages/markets.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/markets"])
      });
    }
  